import React, { Component } from "react"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemText from "@mui/material/ListItemText"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction"
import Grow from "@mui/material/Grow"
import Button from "@mui/material/Button"
import IconButton from "@mui/material/IconButton"
import CircularProgress from "@mui/material/CircularProgress"
import DeleteOutlined from "@mui/icons-material/DeleteOutlined"
import Add from "@mui/icons-material/Add"
import { withTranslation } from "react-i18next"
import queryStringify from "querystringify"

export default withTranslation()(
  class ManageAssets extends Component {
    state = {
      uploadLoading: false,
      deleteLoading: null,
    }

    deleteAsset = async (experienceId, assetName) => {
      const { setExperiences, experiences } = this.props

      this.setState({ deleteLoading: assetName })

      await fetch(
        `${
          process.env.REACT_APP_SERVER_URL
        }/experiences/${experienceId}/assets/${assetName}?password=${localStorage.getItem(
          "password"
        )}`,
        {
          method: "DELETE",
          headers: {},
        }
      ).then(() => {
        setExperiences([
          ...experiences.filter(({ _id }) => _id !== experienceId),
          {
            ...experiences.find(({ _id }) => _id === experienceId),
            assets: experiences
              .find(({ _id }) => _id === experienceId)
              .assets.filter((assetToDelete) => assetToDelete !== assetName),
          },
        ])

        this.setState({ deleteLoading: null })
      })
    }

    render() {
      const { open, close, t, experience, setExperiences, experiences } =
        this.props
      const { uploadLoading, deleteLoading } = this.state

      return (
        <>
          <Dialog
            open={open}
            onClose={close}
            TransitionComponent={Grow}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle
              className="notSelectable"
              style={{ fontWeight: 600 }}
            >{t`Manage assets`}</DialogTitle>
            <DialogContent style={{ padding: 0 }}>
              <List className="notSelectable">
                <ListItem
                  button
                  onClick={() => this.templateUpload.click()}
                  disabled={uploadLoading}
                >
                  <ListItemIcon>
                    {uploadLoading ? (
                      <CircularProgress color="inherit" size={16} />
                    ) : (
                      <Add />
                    )}
                  </ListItemIcon>
                  <ListItemText primary={t`Upload new assets`} />
                </ListItem>
                {experience.assets
                  .sort((a, b) =>
                    a.toLowerCase() > b.toLowerCase()
                      ? 1
                      : a.toLowerCase() < b.toLowerCase()
                      ? -1
                      : 0
                  )
                  .map((asset) => (
                    <ListItem>
                      <ListItemText primary={asset} inset />
                      <ListItemSecondaryAction
                        style={deleteLoading === asset ? { right: "20px" } : {}}
                      >
                        <IconButton
                          onMouseOver={(event) => {
                            event.stopPropagation()
                            this.setState({ hoveredRow: null })
                          }}
                          onClick={(event) => {
                            event.stopPropagation()

                            this.setState({ deleteRoomOpen: true })
                          }}
                          disabled={deleteLoading === asset}
                        >
                          {deleteLoading === asset ? (
                            <CircularProgress size={16} />
                          ) : (
                            <DeleteOutlined
                              style={{ color: "black" }}
                              onClick={() =>
                                this.deleteAsset(experience._id, asset)
                              }
                            />
                          )}
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
              </List>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={close}>{t`Close`}</Button>
            </DialogActions>
          </Dialog>
          <input
            type="file"
            hidden
            multiple
            ref={(ref) => (this.templateUpload = ref)}
            onChange={(event) => {
              event.stopPropagation()
              event.preventDefault()

              Array.from(event.target.files).map(async (body) => {
                const fileName = body.name

                this.setState({ uploadLoading: true })

                await fetch(
                  `${process.env.REACT_APP_SERVER_URL}/experiences/${
                    queryStringify.parse(window.location.search).experience
                  }/assets?password=${localStorage.getItem(
                    "password"
                  )}&fileName=${fileName}`,
                  {
                    method: "POST",
                    body,
                    headers: { "Content-Type": "application/octet-stream" },
                  }
                )
                  .then(() => {
                    setExperiences([
                      ...experiences.filter(
                        ({ _id }) => _id !== experience._id
                      ),
                      {
                        ...experiences.find(
                          ({ _id }) => _id === experience._id
                        ),
                        assets: [
                          ...experiences
                            .find(({ _id }) => _id === experience._id)
                            .assets.filter((asset) => asset !== fileName),
                          ...Array.from(event.target.files).map(
                            ({ name }) => name
                          ),
                        ],
                      },
                    ])
                  })
                  .catch(() => {})

                this.setState({ uploadLoading: false })
              })
            }}
          />
        </>
      )
    }
  }
)
